import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const reviews = [{
  name: 'María García',
  rating: 5,
  comment: 'Increíble libro, aprendí a hacer café como nunca antes. Las recetas son fáciles de seguir.'
}, {
  name: 'Carlos Rodríguez',
  rating: 5,
  comment: 'Perfecto para emprendedores. La guía de cafetería me ayudó a arrancar mi negocio.'
}, {
  name: 'Ana Martínez',
  rating: 4,
  comment: 'Muy completo, las recetas de mixología son espectaculares. Lo recomiendo totalmente.'
}, {
  name: 'Luis Hernández',
  rating: 5,
  comment: 'El mejor recurso sobre café que he encontrado. Vale cada centavo invertido.'
}, {
  name: 'Sofía López',
  rating: 5,
  comment: 'Me encantó la sección de métodos de extracción. Ahora mi café sabe profesional.'
}, {
  name: 'Diego Sánchez',
  rating: 4,
  comment: 'Muy buenas recetas y explicaciones claras. Los bonus son un regalo increíble.'
}, {
  name: 'Valentina Torres',
  rating: 5,
  comment: 'Transformó mi forma de preparar café. Mi familia no puede creer la diferencia.'
}, {
  name: 'Andrés Ramírez',
  rating: 5,
  comment: 'Excelente inversión. Los recetarios de postres y galletas son mis favoritos.'
}, {
  name: 'Camila Flores',
  rating: 4,
  comment: 'Muy útil para quienes amamos el café. Las recetas de matcha también están geniales.'
}, {
  name: 'Javier Morales',
  rating: 5,
  comment: 'Superó mis expectativas. Ahora preparo café de especialidad en casa todos los días.'
}];
function StarRating({
  rating
}: {
  rating: number;
}) {
  return <div className="flex gap-0.5" data-id="element-123">
      {[1, 2, 3, 4, 5].map(star => <Star key={star} className={`w-3 h-3 ${star <= rating ? 'fill-amber-400 text-amber-400' : 'fill-gray-200 text-gray-200'}`} data-id="element-124" />)}
    </div>;
}
export function ReviewsSection() {
  return <section className="py-8 bg-white" data-id="element-125">
      <div className="max-w-4xl mx-auto px-6" data-id="element-126">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-6" data-id="element-127">
          <h2 className="text-xl md:text-2xl font-serif text-coffee-dark mb-3" data-id="element-128">
            Lo que dicen nuestros lectores
          </h2>

          {/* Rating Summary */}
          <div className="flex items-center justify-center gap-2" data-id="element-129">
            <div className="flex gap-0.5" data-id="element-130">
              {[1, 2, 3, 4, 5].map(star => <Star key={star} className={`w-5 h-5 ${star <= 4 ? 'fill-amber-400 text-amber-400' : star === 5 ? 'fill-amber-400/70 text-amber-400' : 'fill-gray-200 text-gray-200'}`} data-id="element-131" />)}
            </div>
            <span className="text-coffee-dark font-semibold" data-id="element-132">4.7</span>
            <span className="text-coffee/50 text-sm" data-id="element-133">(190 reseñas)</span>
          </div>
        </motion.div>

        {/* Reviews Grid - 2 columns */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3" data-id="element-134">
          {reviews.map((review, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="bg-cream/50 border border-coffee-light/10 rounded-lg p-4" data-id="element-135">
              <div className="flex items-center justify-between mb-2" data-id="element-136">
                <span className="font-medium text-coffee-dark text-sm" data-id="element-137">
                  {review.name}
                </span>
                <StarRating rating={review.rating} data-id="element-138" />
              </div>
              <p className="text-coffee/70 text-xs leading-relaxed" data-id="element-139">
                "{review.comment}"
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}